/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Mezisoučet`
};

const da_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotal`
};

const de_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Zwischensumme`
};

const en_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotal`
};

const es_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotal`
};

const fr_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Sous-total`
};

const hu_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Közvetítés`
};

const it_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotale`
};

const nl_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotaal`
};

const pl_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Suma częściowa`
};

const pt_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Subtotal`
};

const sv_subtotal = /** @type {(inputs: {}) => string} */ () => {
	return `Delsumma`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const subtotal = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.subtotal(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("subtotal", locale)
	if (locale === "cs") return cs_subtotal(inputs)
	if (locale === "da") return da_subtotal(inputs)
	if (locale === "de") return de_subtotal(inputs)
	if (locale === "en") return en_subtotal(inputs)
	if (locale === "es") return es_subtotal(inputs)
	if (locale === "fr") return fr_subtotal(inputs)
	if (locale === "hu") return hu_subtotal(inputs)
	if (locale === "it") return it_subtotal(inputs)
	if (locale === "nl") return nl_subtotal(inputs)
	if (locale === "pl") return pl_subtotal(inputs)
	if (locale === "pt") return pt_subtotal(inputs)
	return sv_subtotal(inputs)
};